import React from 'react';
import Spacing from '../../portico/spacing/spacing';
import { useDocumentRequirementsStyles } from './document-requirements.styles';
import Typography from '@material-ui/core/Typography';
import STATIC_TEXT from '../../../content/common.json';
import { useEntityState } from '../../../stores/entity/entity.hooks';
import { isUSEntity } from '../../../utils/fenergo-utils';

export const IndividualDocumentRequirements: React.FC = () => {
    const classes = useDocumentRequirementsStyles();
    const { entityDraft } = useEntityState();

    return (
        <>
        {isUSEntity(entityDraft)? 
            
            // US content
            <>
                <Typography variant="body1">
                    {STATIC_TEXT.welcome.docs.personalInformationUS.line1}
                    {STATIC_TEXT.welcome.docs.personalInformationUS.line1BoldText}
                    {STATIC_TEXT.welcome.docs.personalInformationUS.line1EndText}
                </Typography>
                <div className={classes.list}>
                    {
                        STATIC_TEXT.welcome.docs.personalInformationUS.listGroup
                            .map((_listGroup, _listIndex) => (
                                <ul key={_listIndex} className={classes.listItem}>
                                    {_listGroup.map((_listItem, _index) => <li key={_index}>{_listItem}</li>)}
                                </ul>
                            ))
                    }
                </div>
                <Typography variant="body1">{STATIC_TEXT.welcome.docs.personalInformationUS.line2}</Typography>
                <Spacing variable="spacing-base-x2" />
                <Typography variant="body1">{STATIC_TEXT.welcome.docs.personalInformationUS.line3}</Typography>
            </>:

            // Non-US content
            <>
                <Typography variant="body1">{STATIC_TEXT.welcome.docs.personalInformationUK.paragraph1}</Typography>
                <Spacing variable="spacing-base-x3" />
                <div className={classes.docListingWrapper}>
                    <ul className={classes.listItem}>
                        {
                            STATIC_TEXT.welcome.docs.personalInformationUK.addressProof
                                .map((_address, _index) => <li key={_index}>{_address}</li>)
                        }
                    </ul>
                </div>
                <div className={classes.docListingWrapper}>
                    <ul className={classes.listItem}>
                        {
                            STATIC_TEXT.welcome.docs.personalInformationUK.informationProof
                                .map((_information, _index) => <li key={_index}>{_information}</li>)
                        }
                    </ul>
                </div>
                <Spacing variable="spacing-base-x3" />
                <Typography variant="body1">{STATIC_TEXT.welcome.docs.personalInformationUK.paragraph2}</Typography>
                
            </>
        }
        </> 
    );
};
